import { config } from 'CONFIG';
import i18n from 'LANG';

const timeStamp = process.env.TIME_STAMP;

export const getDeviceSupport = () => {

    return new Promise(( resolve, reject ) => {

        $.get( `https://cdn.reolink.com/wp-content/uploads/2018/public/cloud-support.json?sv=${timeStamp}` ).then( res => {

            resolve( res );

        }).catch( err => {

            reject( err );

        });

    });

};

export function getCountryList () {

    return new Promise(( resolve, reject ) => {

        $.get( `/static/js/countries.json` ).then( res => {

            resolve( res );

        }).catch( err => {

            reject( err );

        });

    });

}

export const getCloudConfig = () => {

    return new Promise(( resolve, reject ) => {

        $.get( config.s3Config ).then( res => {

            resolve( res );

        }).catch( err => {

            reject( err );

        });

    });

};

export const listToString = ( arr ) => {

    let and = i18n.t( 'common.and' );
    let _arr = arr.slice( 0 );

    if ( _arr.length > 1 ) {

        _arr[ _arr.length - 1 ] = `${and} ${_arr[ _arr.length - 1 ]}`;

    }
    return _arr.join( ', ' );

};



// WEBPACK FOOTER //
// ./src/api/s3Config.js